import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const getRegistrationList = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETREGISTRATIONLIST, params);
    return data;
};
const getRegistrationDetails = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETREGISTRATIONDETAILS, params);
    return data;
};

const registrationService = {
    getRegistrationList,
    getRegistrationDetails,
};

export default registrationService;